import { render } from "./tableData.vue?vue&type=template&id=4c454542&scoped=true&ts=true"
import script from "./tableData.vue?vue&type=script&lang=ts"
export * from "./tableData.vue?vue&type=script&lang=ts"

import "./tableData.vue?vue&type=style&index=0&id=4c454542&scoped=true&lang=css"
import "./tableData.vue?vue&type=style&index=1&id=4c454542&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c454542"]])

export default __exports__